import React from 'react';
import Homepage from '../gatsby-theme-carbon/components/Layouts/Homepage';
import BannerImage from '../images/illustration.png';
import Bee from '../visuals/homepage/bee.svg';
import './LandingPageHeader.scss';









const customProps = {
  Banner:

  <div 
    className="cds--grid headerHoneyCombLandingPage" 
    style={{ backgroundImage: `url(${BannerImage})`, minHeight:'18rem'}}
  >
        <div className="cds--row">
          <h1 className='expressiveXLG04'>Accessibility is a team effort.</h1>
        </div> 
        <img src={Bee} alt="" className="bee" />
    </div>
  ,
  FirstCallout: <React.Fragment></React.Fragment>,
  SecondCallout: <React.Fragment></React.Fragment>,
  
  
 
};

// spreading the original props gives us props.children (mdx content)
function ShadowedHomepage(props) {
  return   <Homepage {...props} {...customProps} />
       
}

export default ShadowedHomepage;
